// extracted by mini-css-extract-plugin
export default {"container":"SamlLink_container__C5-Xp","ssoLink":"SamlLink_ssoLink__clvbU","samlButton":"SamlLink_samlButton__oYXpU"};